import { hasOwnProp } from "./helpers/object-util.js";
import jQuery from "jquery";

/**
 * IE9 doesn't support `@placeholder` of HTML5
 */
const testInput = document.createElement("input");
const placeholderNotSupported = testInput.placeholder === undefined;

if (placeholderNotSupported) {
	jQuery(() => {
		const body = jQuery("body")[0];
		// IE8 fix
		if (body.addEventListener) {
			body.addEventListener("DOMNodeInserted", (event) => {
				const input = jQuery(event.target);
				if (input.is("input")) {
					fixPlaceHolderForIE9(input);
				}
			});
		}
	});
}

function fixPlaceHolderForIE9(input) {
	const originalType = input.attr("type");
	if (input.val() === "" && input.attr("placeholder") !== "") {
		input.val(input.attr("placeholder"));
		input.get(0).type = "text";

		input.focus(() => {
			if (input.val() !== input.attr("placeholder")) {
				return;
			}
			input.get(0).type = originalType;
			input.val("");
		});

		input.blur(() => {
			if (input.val() !== "") {
				return;
			}
			input.get(0).type = "text";
			input.val(input.attr("placeholder"));
		});
	}
}

/**
 * Polyfill for Object.assign
 */
if (typeof Object.assign !== "function") {
	(function () {
		Object.assign = function (target) {
			if (target === undefined || target === null) {
				throw new TypeError(
					"Cannot convert undefined or null to object",
				);
			}

			const output = new Object(target);
			for (let index = 1; index < arguments.length; index++) {
				const source = arguments[index];
				if (source !== undefined && source !== null) {
					for (const nextKey in source) {
						if (hasOwnProp(source, nextKey)) {
							output[nextKey] = source[nextKey];
						}
					}
				}
			}
			return output;
		};
	})();
}

// babeljs doesn't translate Array.prototype.includes. The proper fix
// would be to use babel-polyfill.
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
	Object.defineProperty(Array.prototype, "includes", {
		value: function (searchElement, fromIndex) {
			// 1. Let O be ? ToObject(this value).
			if (this === null) {
				throw new TypeError('"this" is null or not defined');
			}

			const o = new Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			const len = o.length >>> 0;

			// 3. If len is 0, return false.
			if (len === 0) {
				return false;
			}

			// 4. Let n be ? ToInteger(fromIndex).
			//    (If fromIndex is undefined, this step produces the value 0.)
			const n = fromIndex | 0;

			// 5. If n ≥ 0, then
			//  a. Let k be n.
			// 6. Else n < 0,
			//  a. Let k be len + n.
			//  b. If k < 0, let k be 0.
			let k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

			// 7. Repeat, while k < len
			while (k < len) {
				// a. Let elementK be the result of ? Get(O, ! ToString(k)).
				// b. If SameValueZero(searchElement, elementK) is true, return true.
				// c. Increase k by 1.
				// NOTE: === provides the correct "SameValueZero" comparison needed here.
				if (o[k] === searchElement) {
					return true;
				}
				k++;
			}

			// 8. Return false
			return false;
		},
	});
}
